<template>
  <customFieldsAddingPreview
    :icon='"number-seven.svg"'
    :name="preloadedItem.name || 'Round Number'">

    <template :slot='"body"'>
      <v-text-field
        dense
        :placeholder="preloadedItem.placholder"
        v-model="value"
        :rules='roundNumberRules'
        single-line
        color="#43425d"
        type="number"
        @keydown='handleInput'
        class="r-field item-name-field"
      />
    </template>
  </customFieldsAddingPreview>
</template>

<script>
import customFieldsAddingPreview from '../customFieldsAddingPreview'
export default {
  props: {
    preloadedItem: {
      type: Object,
      default: () => {
        return {
          name: '',
          placeholder: '',
          defaultValue: null
        }
      }
    }
  },
  data: function() {
    return {
      value: this.preloadedItem.defaultValue,
      roundNumberRules: [
        (v) => v?.length ? /^\d+$/.test(v) || 'Number should be integer' : true
      ]
    }
  },
  watch: {
    'preloadedItem.defaultValue': {
      handler (newDefaultValue, oldDefaultValue) {
        if (this.value === oldDefaultValue) {
          this.value = newDefaultValue
        }
      },
      deep: true
    }
  },
  methods: {
    handleInput(v) {
      if (v.key === ',' || v.key === '.') event.preventDefault()
    }
  },
  components: {
    customFieldsAddingPreview
  }
}
</script>
